import { render, staticRenderFns } from "./live-loading.vue?vue&type=template&id=10c7f3eb&scoped=true&"
import script from "./live-loading.vue?vue&type=script&lang=js&"
export * from "./live-loading.vue?vue&type=script&lang=js&"
import style0 from "./live-loading.vue?vue&type=style&index=0&id=10c7f3eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c7f3eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c7f3eb')) {
      api.createRecord('10c7f3eb', component.options)
    } else {
      api.reload('10c7f3eb', component.options)
    }
    module.hot.accept("./live-loading.vue?vue&type=template&id=10c7f3eb&scoped=true&", function () {
      api.rerender('10c7f3eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/live-loading.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/live-loading.vue
// module id = yKSo
// module chunks = 0